import { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Button';
import ToolbarSuggestionFeedbacks from './ToolbarSuggestionFeedbacks';
import IconButton from './IconButton';

const ToolbarSuggestionActions = ({
  hasSelection,
  onInsert,
  onDiscard,
  onMakeLonger,
  onReplaceSelection,
  onInsertBellow,
  onRephrase,
  onContinueWriting,
  onCopy,
  onMakeShorter,
}) => {
  return (
    <Actions>
      <ActionsGroup>
        {!hasSelection
          ? (<Button size='small' onClick={onInsert}>Insert</Button>)
          : (
            <>
              <Button size='small' onClick={onReplaceSelection}>Replace selection</Button>
              <Button size='small' onClick={onInsertBellow}>Insert bellow</Button>
            </>
          )
        }

        <Button size='small' styleType='secondary' onClick={onDiscard}>Discard</Button>

        <IconButton
          icon='lizzy-refresh'
          tooltip='Rephrase'
          onClick={onRephrase}
        />
        <IconButton
          icon='lizzy-continue-writing'
          tooltip='Continue Writing'
          onClick={onContinueWriting}
        />
        <IconButton
          icon='copy'
          iconSource='feather'
          tooltip='Copy'
          onClick={onCopy}
        />
        <IconButton
          icon='lizzy-shorten'
          tooltip='Shorten'
          onClick={onMakeShorter}
        />
        <IconButton
          icon='lizzy-longer'
          tooltip='Longer'
          onClick={onMakeLonger}
        />
      </ActionsGroup>
      <ActionsGroup>
        <ToolbarSuggestionFeedbacks />
      </ActionsGroup>
    </Actions>
  );
}

export default memo(ToolbarSuggestionActions);

ToolbarSuggestionActions.propTypes = {
  hasSelection: PropTypes.bool.isRequired,
  onMakeLonger: PropTypes.func.isRequired,
  onReplaceSelection: PropTypes.func.isRequired,
  onInsertBellow: PropTypes.func.isRequired,
  onRephrase: PropTypes.func.isRequired,
  onContinueWriting: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  onMakeShorter: PropTypes.func.isRequired,
};

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 0 0;
  margin: 6px 0 0;
`;

const ActionsGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${Button} {
    margin-right: 7px;
  }

  ${IconButton} {
    margin: 0 3px;
    width: 24px;
    height: 24px;
    color: var(--lizzy-black-65);

    i {
      font-size: 18px;
    }

    .feather-icon {
      width: 16px;
      height: 16px;
      margin: 4px;
    }

    .lizzy-icon {
      width: 24px;
      height: 24px;
    }
  }
`;